import axios from "axios";
import Header from "./Component/Header";
import { useEffect, useState } from "react";
import {
  handleGetApiGF,
  handlePostApiGF,
  Toast,
} from "./Component/Utils/general-function";
import Loader from "./Component/Utils/Loader";
import { Link } from "react-router-dom";

const Test2 = () => {
  const [searchtxt, setSearchtxt] = useState("");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(false);

  const OnChange = (e) => {
    setSearchtxt(e.target.value.toUpperCase());
  };

  const rcSearcFetch = async () => {
    if (!(searchtxt || "").trim())
      return Toast(false, "", "Please enter car number");
    setLoading(true);

    try {
      let obj = {
        id_number: searchtxt,
        enrich: "false",
      };

      const res = await axios.post(
        "https://kyc-api.surepass.app/api/v1/rc/rc-v2",
        obj,
        {
          headers: {
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmcmVzaCI6ZmFsc2UsImlhdCI6MTc4NDc4NjkzOSwianRpIjoiYmFlNjlhOTAtMDIwMS00ZWY4LWI4OTctN2QyMzFmNzgyMWNlIiwidHlwZSI6ImFjY2VzcyIsImlkZW50aXR5IjoiZGV2LmNhcnRoaUBzdXJlcGFzcy5pbyIsIm5iZiI6MTc4NDc4NjkzOSwiZXhwIjoyNDE1NTA2OTM5LCJlbWFpbCI6ImNhcnRoaUBzdXJlcGFzcy5pbyIsInRlbmFudF9pZCI6Im1haW4iLCJ1c2VyX2NsYWltcyI6eyJzY29wZXMiOlsidXNlciJdfX0.hqgdQniZ2q9STAKlcNJFfRBIX2omm_JAZpgn_TTFTbI",
          },
        },
      );

      console.log("res", res);
    } catch (error) {
      console.error(error);

      Toast(false, "", error?.message);
    }
    setLoading(false);
  };

  return (
    <div>
      <Header />

      {loading ? <Loader /> : null}
      <div className="content">
        <div className="text-center">
          <h2 className="page-title">Rc search Demo</h2>
        </div>
        <div className="input-group mt-2">
          <input
            type="text"
            className="form-control"
            placeholder="RC Number"
            name="searchtxt"
            value={searchtxt}
            onChange={OnChange}
          />
          <button
            className="btn rc-submit"
            type="submit"
            onClick={rcSearcFetch}
          >
            Submit
          </button>
        </div>
        {/* Display the API response data */}
      </div>
    </div>
  );
};

export default Test2;
